export const fundTypeOptions = [
  { label: "Deuda convertible", value: "DEBT" },
  { label: "Financiamiento", value: "FINACING" },
  { label: "Recaudación de fondos", value: "FUNDRAISING" },
  { label: "Capital privado", value: "PRIVATE_CAPITAL" },
  { label: "Subsidio o donación", value: "SUBSIDY_OR_DONATION" },
  { label: "Otro", value: "OTHER" }
];